// import axios from '@/libs/api.request'
// import config from '@/config'
import user from '@/api/user.api'
import role from '@/api/role.api'
import utils from '@/api/utils.api'
import client from '@/api/client.api'
import project from '@/api/project.api'
import point from '@/api/point.api'
import tiltmeter from '@/api/tiltmeter.api'
import pntData from '@/api/pntdata.api'
// import mockapi from './mockapi'
import station from '@/api/station.api'
import node from '@/api/node.api'
import channel from '@/api/channel.api'
import sensor from '@/api/sensor.api'
import formulaExpression from '@/api/formulaExpression.api'
export default {
  ...station,
  ...node,
  ...channel,
  ...sensor,
  ...user,
  ...role,
  ...utils,
  ...client,
  ...project,
  ...point,
  ...tiltmeter,
  ...pntData,
  ...formulaExpression,
  ...station,
  ...node,
  ...channel,
  ...sensor
}
